import upperFirst from "lodash/upperFirst";
import { FunctionComponent } from "react";
import { useIntl } from "react-intl";
import ButtonSmily from "@Components/atoms/ButtonSmily";
import BottomSheet from "@Components/molecules/BottomSheet";
import CheckoutCreditCardPaymentForm from "@Components/molecules/cart/CheckoutCreditCardPaymentForm";
import { PaymentMethod } from "@Types/cart";
import { FormError } from "@Types/error";
import { getPaymentMethodLogos } from "@Utils/cart/payment";
import "./style.scss";

interface Props {
  disabled: boolean;
  display: boolean;
  enableRememberCreditCard: boolean;
  hasCheckedRememberCreditCard: boolean;
  onDismiss: () => void;
  onRememberCreditCard: () => void;
  onValidate: () => void;
  paymentErrors: FormError[];
  paymentMethod: PaymentMethod | undefined;
}

const CheckoutPaymentBottomSheet: FunctionComponent<Props> = ({
  disabled,
  display,
  enableRememberCreditCard,
  hasCheckedRememberCreditCard,
  onDismiss,
  onRememberCreditCard,
  onValidate,
  paymentErrors,
  paymentMethod,
}) => {
  const intl = useIntl();

  return (
    <BottomSheet display={display} onDismiss={onDismiss} portal={false} showCloseButton={true}>
      <div className="CheckoutPaymentBottomSheet">
        <div className="CheckoutPaymentBottomSheet-title">
          {paymentMethod === "cc"
            ? intl.formatMessage({
                id: "cheerz_CheckoutPaymentBottomSheet_title__ccPayment",
              })
            : intl.formatMessage(
                {
                  id: "cheerz_CheckoutPaymentBottomSheet_title__alternatePayment",
                },
                {
                  paymentMethod: upperFirst(paymentMethod),
                }
              )}
        </div>
        {paymentMethod &&
          getPaymentMethodLogos(paymentMethod).map((logo) => (
            <img className="CheckoutPaymentBottomSheet-image" key={logo} src={logo} />
          ))}

        {paymentMethod === "cc" && (
          <CheckoutCreditCardPaymentForm
            disabled={disabled}
            enableRememberCreditCard={enableRememberCreditCard}
            hasCheckedRememberCreditCard={hasCheckedRememberCreditCard}
            onRememberCreditCard={onRememberCreditCard}
            paymentErrors={paymentErrors}
          />
        )}

        {paymentMethod !== "cc" && (
          <div className="CheckoutPaymentBottomSheet-description">
            {intl.formatMessage(
              {
                id: "cheerz_CheckoutPaymentBottomSheet_description",
              },
              {
                paymentMethod: upperFirst(paymentMethod),
              }
            )}
          </div>
        )}

        {paymentMethod && (
          <ButtonSmily onClick={onValidate} size="m" type="primary">
            {intl.formatMessage({
              id:
                paymentMethod !== "cc"
                  ? "cheerz_CheckoutPaymentBottomSheet_button__alternatePayment"
                  : "cheerz_CheckoutPaymentBottomSheet_button__ccPayment",
            })}
          </ButtonSmily>
        )}
      </div>
    </BottomSheet>
  );
};

export default CheckoutPaymentBottomSheet;
